// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.5 1.5 L14.5 1.5 L14.5 5.5 M14.5 1.5 L10 6',
  'M14.5 10.5 L14.5 14.5 L10.5 14.5 M14.5 14.5 L10 10',
  'M5.5 14.5 L1.5 14.5 L1.5 10.5 M1.5 14.5 L6 10',
  'M1.5 5.5 L1.5 1.5 L5.5 1.5 M1.5 1.5 L6 6',
];
